<template>

  
    <svg width="100%" height="100%" viewBox="0 0 42 42">      
        <circle cx="21" cy="21" r="16" fill="transparent" stroke="blue"  stroke-width="5" stroke-dasharray="10 0 0 100" stroke-dashoffset="10"></circle>      
        <circle cx="21" cy="21" r="16" fill="transparent" stroke="red"   stroke-width="5" stroke-dasharray="10 0 0 25" stroke-dashoffset="20"></circle>      
        <circle cx="21" cy="21" r="16" fill="transparent" stroke="green" stroke-width="5" stroke-dasharray="10 0 0 25" stroke-dashoffset="30"></circle>      
        <circle cx="21" cy="21" r="16" fill="transparent" stroke="gold" stroke-width="5" stroke-dasharray="10 0 0 25" stroke-dashoffset="40"></circle>      
    </svg>
  
  
</template>
<script>


  export default {
      data() {return {
        ctx: undefined,
        items:[
          {color:'red', value:10, title:'Plumbing'},
          {color:'blue', value:20, title:'Carpenter'},
          {color:'green', value:30, title:'HVCD'},
          {color:'yellow', value:40, title:'Concrete'},
        ],
      }},
      props:{
        values: {type: [], default: [10,10,10]},
        colors: {type: [], default: ['red','blue','green']},        
      },
      mounted(){

        let canvas = this.$refs.c
        canvas.width = canvas.height = 140;
        this.ctx = canvas.getContext("2d");
        this.draw(70, 70, 50, 20)
      },
      methods:{
        draw(cx, cy, radius, arcwidth) {
          var accum = 0;
          var PI = Math.PI;
          var PI2 = PI * 2;
          var offset = -PI / 2;
          var canvasValues = this.values
          var canvasColors = this.colors
          var tot = canvasValues.reduce((a, b) => a + b, 0)

          this.ctx.lineWidth = arcwidth;
          // this.ctx.lineCap = "round";

          for (var i = 0; i < canvasValues.length; i++) {
            this.ctx.beginPath();
            this.ctx.arc(cx, cy, radius, offset + PI2 * (accum / tot), offset + PI2 * ((accum + canvasValues[i]) / tot));
            this.ctx.strokeStyle = canvasColors[i];
            this.ctx.stroke();
            accum += canvasValues[i];
          }

          this.ctx.beginPath();
          this.ctx.arc(cx, cy, radius, offset, offset);
          this.ctx.strokeStyle = canvasColors[0];
          this.ctx.stroke();
        }
      },
      
  }
</script>

<style scoped>
.dashboard-balance {
    width: 350px;
    height: 400px;
    box-sizing: border-box;
}

.chart-text {
    font-family: sans-serif;
    fill: #000;
    transform: translateY(0.25em);
}

.chart-number {
    font-size: 0.15em;
    line-height: 1;
    text-anchor: middle;
    transform: translateY(-0.25em);
}

.chart-label {
    font-size: 0.15em;
    font-weight: bold;
    text-transform: uppercase;
    text-anchor: middle;
    transform: translateY(0.7em);
}


/* .maskWood {
  -webkit-mask-image: url(../../../public/images/pattern/wood.png);
  mask-image: url(../../../public/images/pattern/wood.png);
  mask-repeat: no-repeat;    
} */
.maskWood {  
  /* background-image: url(../../../public/images/pattern/wood.png); */
  background-repeat: repeat;    
}

</style>